import * as React from 'react';
export const IcFamilyMember = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7 8a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm5 7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm5-7a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm2.72 1.93A3.81 3.81 0 0017 9c-.61 0-1.213.13-1.77.38a4.44 4.44 0 01.35 5.81A6 6 0 0118 20c0 .341-.06.68-.18 1H19a1.911 1.911 0 002-1.83V12.5a3.78 3.78 0 00-1.28-2.57zm-12.21 2.3a4.4 4.4 0 011.26-2.84A4.33 4.33 0 007 9a3.76 3.76 0 00-4 3.5v6.67A1.91 1.91 0 005 21h1.18A2.85 2.85 0 016 20a6 6 0 012.42-4.8 4.41 4.41 0 01-.91-2.97zM12 16a4 4 0 00-4 4 1 1 0 001 1h6a1 1 0 001-1 4 4 0 00-4-4z'
      fill='currentColor'
    />
  </svg>
);
